export default "__VITE_ASSET__BTdbVKcr__"